import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWorkspaceBalance } from '@shared/dto/+workspace/workspace_balance/dto_workspace_balance';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWorkspaceBilling } from './state_workspace_billing';

export const local_workspace_billing_balance_upsert = (payload: DTOWorkspaceBalance[]): PayloadAction<DTOWorkspaceBalance[]> => ({
  type: ENUM__redux_action.WORKSPACE_BILLING_BALANCE_UPSERT,
  payload,
});

export const init_local_workspace_billing_balance_upsert = (state: StateWorkspaceBilling, action: PayloadAction<DTOWorkspaceBalance[]>) => {
  if (action.payload.is_empty()) return;

  for (let item of action.payload) {
    state.balances_map.set(item._id, item);
  }

  //nned to force a re-render
  state.balances_map = new Map(state.balances_map);
};
